'use strict';

/* Directives */

angular.module('substoreApp.directives')

    /**
     * Renders the 'print order form' (PDF) part.
     */
    .directive('capOrderFormGeneration', ["uiservice", "sessionData", "throwServiceResponseFault", function (uiservice, sessionData, throwServiceResponseFault) {
        return {
            restrict: 'A',
            scope: {
                theData: '=',
                oformFeatureEnabled: '=',
                allowOrderFormGeneration: '=',
                allowReservationEmail: '=',
                allowFinalization: '=',
                isOnlyReservationAllowed: '=',
                confirmation: '='
            },
            controller: ["$scope", function($scope) {
                $scope.printPdf = function printPdf() {
                    uiservice.orderFormGeneration({
                            sessionId: sessionData.sessionId,
                            subscriptionTemplateId: $scope.theData.product.subscriptionTemplateId,
                            onlyReservationAllowed: $scope.isOnlyReservationAllowed,
                            customerEmail: $scope.confirmation.customerEmail
                        },
                        function success(response) {
                            var downloadPath = "/substore/uiservice/orderFormDownload"
                                +"?sessionId="+sessionData.sessionId
                                +"&fileId="+response.data.fileId
                                +"&csrfProtectionToken="+sessionData.csrfProtectionToken;
                            window.open(downloadPath, '_self', '');
                        },
                        throwServiceResponseFault
                    );
                };
            }],
            templateUrl: "templates/orderFormGeneration.html"
        };
    }]);